var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgLightblueCar = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 512 300.999"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2",
  d: "M472.93 109.58l-58.94-17.83-.1-.1-40.505-20.727L352.93 30 327.67 4.45A15.067 15.067 0 00317 0H106.69a14.988 14.988 0 00-13.37 8.21L51.8 89.93H35a35.038 35.038 0 00-35 35V151l10 14.077L0 181v3.23a55.061 55.061 0 0054.89 55H497a15.005 15.005 0 0015-15v-62a54.685 54.685 0 00-39.07-52.65z",
  fill: "#cdebfc"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3",
  d: "M512 162.23v62a15.005 15.005 0 01-15 15H241.88V0H317a15.067 15.067 0 0110.67 4.45L352.93 30l20.45 40.92 40.51 20.73.1.1 58.94 17.83A54.685 54.685 0 01512 162.23z",
  fill: "#bfe1fd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 4",
  d: "M413.89 91.65l-277.23-.51a15.121 15.121 0 01-15.08-15.13l.061-31.039a15 15 0 0115-14.971H352.93z",
  fill: "#91e0fc"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 5",
  d: "M413.89 91.65l-172.01-.32V30h111.05z",
  fill: "#6cbbed"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 12",
  d: "M512 162.23v17.36h-49a15 15 0 010-30h47.56a55.539 55.539 0 011.44 12.64z",
  fill: "#ff9803"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 13",
  d: "M121.692 178.692a61.153 61.153 0 1061.154 61.153 61.224 61.224 0 00-61.154-61.153z",
  fill: "#465a61"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 14",
  d: "M121.692 271a31.154 31.154 0 1131.154-31.154A31.19 31.19 0 01121.692 271z",
  fill: "#f0f0f7"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 15",
  d: "M391.231 178.692a61.153 61.153 0 1061.154 61.153 61.224 61.224 0 00-61.154-61.153z",
  fill: "#2f4247"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 16",
  d: "M391.231 271a31.154 31.154 0 1131.154-31.154A31.19 31.19 0 01391.231 271z",
  fill: "#e6e7f5"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 17",
  d: "M46 166a15.005 15.005 0 01-15 15H0v-30h31a15.005 15.005 0 0115 15z",
  fill: "#ed6c7b"
})));
export default SvgLightblueCar;